import React, { useEffect, useMemo, useRef, useState } from 'react'
import MarkdownWrapper from '../utils/markdown-wrapper'

const StorySection = ({ index, section, color, isMobile = false, inActive = null, onSetActiveSectionNum }) => {
    const [isIntersecting, setIsIntersecting] = useState(false)
    const ref = useRef(null)

    const observer = useMemo(() =>
        new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), { threshold: 0.5 }
        ), [])

    useEffect(() => {
        observer.observe(ref.current)
        return () => {
            observer.disconnect()
        }
    }, [ref, observer])

    useEffect(() => {
        if (isIntersecting && onSetActiveSectionNum) {
            onSetActiveSectionNum(index)
        }
    }
    , [index, isIntersecting])

    let style = !isMobile ? { zIndex: `${(20 - index) * 2}` } : {}
    let layout = section.section_content[0].layout ? section.section_content[0].layout : 'images_to_right'
    return (
        <div
            id={`section-${index}`}
            ref={ref}
            style={style}
            className={`section ${color}-bg ${inActive ? 'inactive' : ''} ${layout}`}>
            { section.section_bg_top &&
                <div className="section-top-bg" style={{ backgroundImage: `url(${section.section_bg_top.url})` }} />
            }
            { section.section_bg_bottom &&
                <div className="section-bottom-bg" style={{ backgroundImage: `url(${section.section_bg_bottom.url})` }} />
            }
            <div className="section-content-wrapper">
                <div className="section-text">
                    <MarkdownWrapper content={section.section_content[0].content} />
                </div>
                { section.section_content[0].images.length > 0 && layout !== 'text_only' &&
                    <div className={`section-image section-image-first`}>
                        <img src={section.section_content[0].images[0].image?.url} alt={section.section_content[0].images[0].image?.alt} />
                    </div>
                }
                { section.section_content[0].images.length > 1 && layout !== 'text_only' &&
                    <div className={`section-image section-image-second`}>
                        <img src={section.section_content[0].images[1].image?.url} alt={section.section_content[0].images[1].image?.alt} />
                    </div>
                }
            </div>
        </div>
    )
}

export default StorySection
